import React, { Component } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import { ArrowLeft, Close } from './icons'
import Select from 'react-select'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class AppraisalForm extends Component {

  constructor(props) {
    super(props)
    this.form = React.createRef()
    this.state = {
      popup: true,
      alerts: 'off',
      officeEmail: 'property@ch.com.au',
      office: 'Office Not Set',
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  _selectChange = (option) => {
    this.setState({
      ...this.state,
      office: option.label,
      officeEmail: option.value,
    })
  }

  handleCheckboxChange = e => {
    let prevValue = this.state[e.target.name] || []
    if (e.target.checked) {
      prevValue.push(e.target.value)
    } else {
      prevValue = prevValue.filter((el) => el !== e.target.value)
    }
    this.setState({ [e.target.name]: prevValue })
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // https://zapier.com/editor/190553168/published/190553168
    fetch(`https://hooks.zapier.com/hooks/catch/2181815/3us6eko/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        ...this.state
      })
    })
      .then(() => {
        this.setState({ result: "success" })
      })
      .catch(error => this.setState({ result: "fail", msg: error }))
  }

  render() {
    let props = {
      ref: this.form,
      name: 'appraisal',
      className: 'form',
      onSubmit: this.handleSubmit,
    }

    // fill out officeOptions from the below select
    let officeOptions = [
      { value: 'drummoyne@ch.com.au', label: 'Drummoyne' },
      { value: 'property@ch.com.au', label: 'Balmain' },
      { value: 'annandale@ch.com.au', label: 'Annandale' },
      { value: 'petersham@ch.com.au', label: 'Petersham' },
      { value: 'admin.marrickville@ch.com.au', label: 'Earlwood' },
      { value: 'receptionlanecove@ch.com.au', label: 'Lane Cove' },
    ]
      
    if (this.state.result === 'success') {
      return (
        <div className={`modal${this.state.popup ? ' active' : ''}`}>
          <div className='modal__close-bg' onClick={() => this.setState({ popup: false })} />
          <div className='modal__inner'>
            <button className='modal__close' onClick={() => this.setState({ popup: false })}>
              <Close color='#000000' />
            </button>
            <div className='modal__wrapper'>
              <div className='modal__thank'>
                <h2>Your message has been sent.<br />
                Thanks for enquiring, someone from our team will be in touch shortly.</h2>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <form {...props}>
        <p>I’m looking for:</p>
        <div className='form__row form__row--double'>
          <div className='form__item form__checkbox'>
            <input type='checkbox' id='checkbox-1' value="Sales Appraisal" name='type' onChange={this.handleCheckboxChange} />
            <label htmlFor='checkbox-1'>
              <p>Sales Appraisal</p>
            </label>
          </div>

          <div className='form__item form__checkbox'>
            <input type='checkbox' id='checkbox-2' value="Rental Appraisal" name='type' onChange={this.handleCheckboxChange} />
            <label htmlFor='checkbox-2'>
              <p>Rental Appraisal</p>
            </label>
          </div>

          <div className='form__item form__checkbox'>
            <input type='checkbox' id='checkbox-3' value="General enquiry" name='type' onChange={this.handleCheckboxChange} />
            <label htmlFor='checkbox-3'>
              <p>General enquiry</p>
            </label>
          </div>
        </div>

        <div className='form__row'>
          <div className="form__row">
            <div className="form__select">
              <label htmlFor="officeList">
                <span>What is your closest office?</span>
              </label>
              <Select
                options={officeOptions}
                onChange={this._selectChange}
                openMenuOnFocus={true}
                isSearchable={false}
                id="officeList"
                name="officeList"
                placeholder="Please select"
                className="react-select-container"
                classNamePrefix="react-select"
                required
              />
            </div>
          </div>
        </div>

        {/* <p>Appraisal Purpose:</p>
        <div className='form__row form__row--double'>
          <div className='form__item form__checkbox'>
            <input type='checkbox' id='checkbox-4' value="I’m looking to sell my property" name='purpose' onChange={this.handleCheckboxChange} />
            <label htmlFor='checkbox-4'>
              <p>I’m looking to sell my property</p>
            </label>
          </div>

          <div className='form__item form__checkbox'>
            <input type='checkbox' id='checkbox-5' value="I’m looking for an update and property advice" name='purpose' onChange={this.handleCheckboxChange} />
            <label htmlFor='checkbox-5'>
              <p>I’m looking for an update and property advice</p>
            </label>
          </div>
    </div> */}

        <div className='form__row form__address'>
          <label htmlFor='email'>Address of Property for Appraisal</label>
          <input
            type='text'
            name='address'
            required
            onChange={this.handleChange}
          />
        </div>

        <div className='form__row form__address'>
          <label htmlFor='email'>Suburb</label>
          <input
            type='text'
            name='suburb'
            required
            onChange={this.handleChange}
          />
        </div>

        <div className='form__row form__row--double'>
          <div className='form__item'>
            <label>First Name</label>
            <input
              type='text'
              name='first_name'
              onChange={this.handleChange}
              required
            />
          </div>
          <div className='form__item'>
            <label htmlFor='phone'>Last Name</label>
            <input
              type='text'
              name='last_name'
              onChange={this.handleChange}
              required
            />
          </div>
        </div>

        <div className='form__row form__row--double'>
          <div className='form__item'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              name='email'
              onChange={this.handleChange}
              required
            />
          </div>
          <div className='form__item'>
            <label htmlFor='phone'>Contact Number</label>
            <input
              type='text'
              name='phone'
              onChange={this.handleChange}
              required
            />
          </div>
        </div>

        <div className='form__row'>
          <label htmlFor='phone'>Message (optional)</label>
          <textarea name='message' onChange={this.handleChange} />
        </div>

        <div className='form__row form__row--submit'>
          <div className='form__checkbox'>
            <input type='checkbox' name='alerts' id='alerts' onChange={this.handleChange} />
            <label htmlFor='alerts'><span>I would like to receive regular market updates</span></label>
          </div>
          <button type='submit' className='btn'>
            <span>Send</span>
          </button>
        </div>
      </form>
    )
  }
}

const Appraisal = ({ title, image }) => {

  return (
    <section className='appraisal'>
      <div className='appraisal__back'>
        <Link to='/'>
          <ArrowLeft color='#0F2130' />
          Back
        </Link>

        {title && <h1>{title}</h1>}
      </div>

      <div className='appraisal__inner'>
        <div className='appraisal__form'>
          {title && <h1>{title}</h1>}

          <AppraisalForm />
        </div>

        <div className='appraisal__image'>
          {image?.localFile && <GatsbyImage image={image.localFile.childImageSharp.gatsbyImageData} alt='' />}
        </div>
      </div>
    </section>
  )
}

export default Appraisal